module.exports = __webpack_public_path__ + "img/drone-footer2.13e3a7fa.jpg";